import React, { useState } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  ButtonToolbar,
  ButtonGroup,
  Button,
  Table,
} from "reactstrap";
//import DriversComponent from "../DriversOld/DriversComponent";
import { useMountEffect } from "app/utils/hooks";
import "./DriversLicensePOC.scss";
import Title from "app/views/commonComponents/Title/Title";
//import profileImage from "../../../../../../assets/images/driverDetails/profileImage.png";
//import FieldNameValue from "../../../../commonComponents/FieldNameValue/FieldNameValue";
import Buttons from "app/views/commonComponents/Buttons/Buttons";
import updateAssignments from "../../../../../../assets/images/profile/updateAssignments.svg";
import addImage from "../../../../../../assets/images/credentials/addImage.png";
import location from "../../../../../../assets/images/credentials/location.svg";
import calendar from "../../../../../../assets/images/credentials/calendar.svg";
import radiationAlt from "../../../../../../assets/images/credentials/radiationAlt.svg";
import greyArrow from "../../../../../../assets/images/credentials/greyArrow.svg";
import redArrow from "../../../../../../assets/images/credentials/redArrow.svg";
import showPreviousLicences from "../../../../../../assets/images/credentials/showPreviousLicences.svg";
import Labels from "app/views/commonComponents/Labels/Labels";
import OptionsMenu from "app/views/commonComponents/OptionsMenu/OptionsMenu";
import showHistory from "../../../../../../assets/images/credentials/showHistory.svg";
import editInformation from "../../../../../../assets/images/credentials/editInformation.svg";
const DriversLicensePOC = ({ handleMenuClick, optionsMenuOpen }) => {
  //const [optionsMenuOpen, setOptionsMenuOpen] = useState(false);
  const menuList = [
    { item: "Show History", icon: showHistory },
    { item: "Edit Information", icon: editInformation },
  ];
  const handleOptionsMenu = () => {
    //setOptionsMenuOpen(!optionsMenuOpen);
  };
  return (
    <>
      <div className="driversLicenseConatiner">
        <div className="profile-title">
          <div style={{ flex: "1" }}>
            <Title name={"Driver's License"} type={"card"} />
          </div>
          <div style={{ flex: "" }}>
            <Buttons
              dimensions={"responsive"}
              iconPosition="left"
              buttonType="secondary"
              size="small"
              image={updateAssignments}
            >
              Update Information
            </Buttons>
          </div>
        </div>
        <div className="licences">
          <div className="licenseDetails">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                alignSelf: "stretch",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "24px",
                  flex: "1",
                }}
              >
                <div className="addLicense">
                  {" "}
                  <div>
                    <img src={addImage} />
                  </div>
                  <div className="licenseNumberValidation">
                    <div className="licenseNumber">T00324BHR323</div>
                    <div className="licenseValidation">
                      Dec 12 2018 - Current
                    </div>
                  </div>
                </div>
                <div className="licenseTypeDetails">
                  <div className="licenseTypeValidation">
                    <div className="licenseType">CDL</div>
                    <div className="licenseDot">.</div>{" "}
                    <div className="licenseType">Class B</div>{" "}
                    <div className="licenseDot">.</div>
                    <div className="licenseLocation">
                      <img src={location} />
                      <div className="licenseType">Texas</div>
                    </div>
                    <div className="licenseDot">.</div>
                    <div className="licenseLocation">
                      <img src={calendar} />
                      <div className="licenseExpireValue">License Expires:</div>
                      <div className="licenseExpireDate">Dec 24, 2028</div>
                    </div>
                    <div className="licenseDot">.</div>
                    <div className="licenseLocation">
                      <img src={radiationAlt} />
                      <div className="licenseExpireValue">Hazmat Expires:</div>
                      <div className="licenseExpireDate">Dec 1, 2028</div>
                    </div>
                  </div>
                  <div className="licenseLabels">
                    <Labels
                      labelType="light"
                      labelTag="grey"
                      arrow={false}
                      image={greyArrow}
                    >
                      Hazmat
                    </Labels>
                    <Labels
                      labelType="light"
                      labelTag="grey"
                      arrow={false}
                      image={greyArrow}
                    >
                      Passenger
                    </Labels>{" "}
                    <Labels
                      labelType="light"
                      labelTag="grey"
                      arrow={false}
                      image={greyArrow}
                    >
                      Tanker
                    </Labels>
                    <Labels
                      labelType="light"
                      labelTag="red"
                      arrow={false}
                      image={redArrow}
                    >
                      Corrective Lenses
                    </Labels>{" "}
                    <Labels
                      labelType="light"
                      labelTag="red"
                      arrow={false}
                      image={redArrow}
                    >
                      Daytime Driving
                    </Labels>
                  </div>
                </div>
              </div>
              <div style={{ flex: "" }}>
                <OptionsMenu
                  menuList={menuList}
                  //onClick={handleOptionsMenu}
                  onClick={handleMenuClick}
                  optionsMenuOpen={optionsMenuOpen}
                />
              </div>
            </div>
          </div>
          {/* <div className="previousLicences">
            <Buttons
              dimensions={"responsive"}
              iconPosition="left"
              buttonType="ghost"
              size="small"
              image={showPreviousLicences}
            >
              Show Previous Licences
            </Buttons>{" "}
          </div> */}
        </div>
      </div>
    </>
  );
};
export default DriversLicensePOC;
